<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { AtomIcon, AtomText } from "@chatfood/design-system";
import { computed } from "vue";
import { useBasketStore } from "~/stores/basket";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("basket-icon-badge");
const { t } = useLocale();
const basket = useBasketStore();

const ariaLabel = computed(() =>
  t("components.basket_icon_badge.label", { count: basket.totalQuantity }),
);
</script>

<template>
  <div :class="css('')" :aria-label="ariaLabel">
    <AtomIcon name="basket" color="color-text-body" aria-hidden="true" />
    <AtomText
      v-if="basket.totalQuantity > 0"
      :class="css('badge')"
      type="small-bold"
      color="color-on-primary"
      tag="span"
    >
      {{ basket.totalQuantity }}
    </AtomText>
  </div>
</template>

<style lang="scss" scoped>
.basket-icon-badge {
  position: relative;
  display: inline-flex;
  padding-inline-end: 8px;

  &__badge {
    position: absolute;
    top: -9px;
    inset-inline-end: -2px;
    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
  }
}
</style>
